'use strict';

module.exports = [require('./code'), require('./bold'), require('./italic'), require('./strikethrough'), require('./text'), require('./image'), require('./link'), require('./footnote-ref'), require('./html')];